import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper("#js-new-swiper", {
  autoplay: {
    delay: 3500,
  },
  breakpoints: {
    768: {
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
  },
  centeredSlides: true,
  loop: true,
  spaceBetween: 0,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  slidesPerView: 1,
});
